import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=1095933c&"
import script from "./suggest.vue?vue&type=script&lang=js&"
export * from "./suggest.vue?vue&type=script&lang=js&"
import style0 from "./suggest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports